import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, Typography, useViewport } from '@chilecompra/react-kit'
import { handleKeyDown, useAccessibility } from '../../../modules/utils/accesibility'
import { DialogButtonContainer, DialogContainer, DialogSubContainer, Link } from './RegisterWizardWelcome.styles'
import { REACT_APP_AHESION_COVENANT_FILE_URL } from '../../../config/settings/environment'

/**
 * The volunteers modal component.
 */
const VolunteersModal = props => {
  const { open, onClose } = props
  const { size } = useViewport()
  const modalRef = useRef(null)

  const onHandleKeyDown = event => () => handleKeyDown(event, onClose)

  useAccessibility(open, size, modalRef)

  return (
    <>
      <Dialog
        onClose={onClose}
        open={open}
        maxWidth="774px"
        margin={size.isTiny ? '84px 18px auto 18px' : '0 auto'}
        padding="16px"
        verticalAlign="center"
        aria-labelledby="volunteers-modal-title"
        aria-describedby="volunteers-modal-description"
        ref={modalRef}
      >
        <DialogContainer>
          <DialogSubContainer>
            <Typography tabIndex="0" id="volunteers-modal-title" fontWeight="bold" variant="h4" textAlign="left">
              Registro Voluntario en Mercado Público
            </Typography>

            <Typography
              tabIndex="0"
              id="volunteers-modal-description"
              margin="16px 0 0"
              variant="body2"
              textAlign="left"
            >
              Para registrar tu institución de forma voluntaria debes utilizar el formulario de registro, considerando
              que quien tenga la representación de tu institución deberá firmar el siguiente{' '}
              <Link
                tabIndex="0"
                aria-label="convenio de adhesión"
                color="primary"
                href={REACT_APP_AHESION_COVENANT_FILE_URL}
                target="_blank"
                rel="noopener noreferrer"
                underline="true"
              >
                convenio de adhesión
              </Link>{' '}
              mediante el uso de Clave Única.
            </Typography>

            <Typography tabIndex="0" margin="16px 0 0" fontWeight="bold" variant="body2" textAlign="left">
              ¿Qué se entiende por autoridad con poder de representación?
            </Typography>

            <Typography tabIndex="0" margin="16px 0 0" variant="body2" textAlign="left">
              Es la persona natural que tiene la facultad para obligar a la institución que representa, a través de su
              firma. Por ejemplo, en una municipalidad, es el alcalde electo, mientras que en una corporación municipal,
              el director de la misma.
            </Typography>
          </DialogSubContainer>
          <DialogButtonContainer>
            <Button
              tabIndex="0"
              aria-label="Cerrar"
              color="default"
              size="medium"
              onClick={onClose}
              onKeyDown={onHandleKeyDown}
            >
              Cerrar
            </Button>
          </DialogButtonContainer>
        </DialogContainer>
      </Dialog>
    </>
  )
}

VolunteersModal.defaultProps = {
  onClose: () => undefined,
  open: false
}

VolunteersModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool
}

export default VolunteersModal
